import { type DisabledPrevButtonType } from '../reducers/app/appTypes';
import type { OperationPage } from '../types/app';

export const getActiveStep = (
  disabledPrevButton: DisabledPrevButtonType,
  page: OperationPage,
): number => {
  if (page === 'services') {
    return disabledPrevButton === 'services' ? 1 : 2;
  }
  if (page === 'timeslots') {
    return disabledPrevButton === 'timeslots'
      ? 1
      : disabledPrevButton === 'services'
        ? 2
        : 3;
  }
  if (page === 'contact') {
    return disabledPrevButton === 'timeslots'
      ? 2
      : disabledPrevButton === 'services'
        ? 3
        : 4;
  }
  return 1;
};

export const getTotalSteps = (
  disabledPrevButton: DisabledPrevButtonType,
): number => {
  switch (disabledPrevButton) {
    case 'services':
      return 3;
    case 'timeslots':
      return 2;
    default:
      return 4;
  }
};
